import http from '@/utils/http/index';

// 获取授权捕获设置
export function getAuthCapture(params) {
  return http.get('/merchant/authSetting/get', { params });
}

// 保存授权捕获设置
export function saveAuthCapture(params) {
  return http.post('/merchant/authSetting/update', params);
}
